<mat-drawer-container class="drawer-container" autosize>
  <mat-drawer
    #drawer
    class="drawer-sidenav"
    id="drawer-sidenav"
    [mode]="modeMenu"
    [opened]="open">
    <app-menu></app-menu>
  </mat-drawer>
  <div class="drawer-sidenav-content">
    <app-idle></app-idle>

    <div
      class="flex flex-row items-center"
      [class.mr-3]="modeMenu == 'over' && !open">
      <div class="flex-1">
        <app-header></app-header>
      </div>
      <div class="!mb-1">
        @if(modeMenu == 'over' && !open) {

        <button mat-icon-button aria-label="Menu" (click)="drawer.toggle()">
          <mat-icon>menu</mat-icon>
        </button>

        }
      </div>
    </div>

    <div>
      <router-outlet />
    </div>
  </div>
</mat-drawer-container>
<app-loading></app-loading>
